import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { MessageBanner }from '@nhl/nhl-react-ui/lib/MessageBanner';

import HeaderMenu from '../../components/headerMenu';
import HeaderScoreboard from '../../components/headerScoreboard';
import Footer from '../../components/footer/Footer';
import { withComponentSeasons, withSeasons } from '../../enhancers';

const HeaderScoreboardWithSeasons = withComponentSeasons(withSeasons(HeaderScoreboard, false));

import './styles.scss';

const PageWrapper = ({
     authenticated = false,
     isAccountApp = false,
     hideWrapperContent = false,
     wrapperClassName = null,
     children
}) => {
    const location = useLocation();

    useEffect(() => {
        sendGoogleAnalyticsPageView();
    }, [location.pathname]);

    const sendGoogleAnalyticsPageView = () => {
        window.dataLayer.push({
            event: 'page_view',
            page_path: location.pathname,
        });
    };

    return (
        <div id="wrapper" className={(authenticated ? 'auth' : 'public') + (wrapperClassName ? ' ' + wrapperClassName : '')}>
            <MessageBanner/>
            {!hideWrapperContent &&
                <header>
                    {authenticated && <HeaderScoreboardWithSeasons isAccountApp={isAccountApp}/>}
                    <HeaderMenu isAccountApp={isAccountApp} authenticated={authenticated}/>
                </header>
            }
            <div className="main-section">
                <main className="content">
                    {children}
                </main>
            </div>
            {!hideWrapperContent && <Footer authenticated={authenticated} />}
        </div>
    );
};

export default PageWrapper;
